import * as reduxLogger from './reduxLogger';
export default {
  reduxLogger: reduxLogger
};